import { type ActorRefFrom, type MachineImplementationsFrom, setup } from 'xstate5';

import { Actions, Guards } from './setup';
import { type Context, type Event, type Input } from './types';

// ─── Model ───────────────────────────────────────────────────────────────────

const model = setup({
  types: {
    input: {} as Input,
    context: {} as Context,
    events: {} as Event,
  },
  guards: {
    checkIfCanSelectMore: Guards.checkIfCanSelectMore,
    checkIfHasPendingProduct: Guards.checkIfHasPendingProduct,
    checkIfHasSelectedProducts: Guards.checkIfHasSelectedProducts,
  },
  actions: {
    //
    // ─── Internal Actions ────────────────────────────────────────────────

    clearPendingProduct: Actions.clearPendingProduct,
    confirmPendingProduct: Actions.confirmPendingProduct,
    removeSelectedProduct: Actions.removeSelectedProduct,
    storePendingProduct: Actions.storePendingProduct,

    // ─── External Actions ────────────────────────────────────────────────

    onProductConfirmed: () => {},
  },
});

// ─────────────────────────────────────────────────────────────────────────────

export const bundleMachine = model.createMachine({
  initial: 'ready',
  context: () => ({
    selectedProducts: [],
    pendingProduct: undefined,
    nextSelectionId: 0,
  }),
  states: {
    ready: {
      initial: 'idle',
      states: {
        idle: {
          on: {
            OPEN_SELECT: {
              guard: 'checkIfCanSelectMore',
              target: 'selecting',
            },
            REMOVE_SELECTED: {
              actions: 'removeSelectedProduct',
            },
            ADD_TO_BAG: {
              guard: 'checkIfHasSelectedProducts',
              target: 'adding',
            },
          },
        },
        selecting: {
          on: {
            SELECT: {
              actions: 'storePendingProduct',
            },
            CONFIRM_SELECT: {
              guard: 'checkIfHasPendingProduct',
              target: 'idle',
              actions: ['confirmPendingProduct', 'onProductConfirmed'],
            },
            CLOSE_SELECT: {
              target: 'idle',
              actions: 'clearPendingProduct',
            },
          },
        },
        adding: {},
      },
    },
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type BundleMachineActorRef = ActorRefFrom<typeof bundleMachine>;
export type BundleMachineImplementations = MachineImplementationsFrom<typeof bundleMachine>;
